import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col } from 'reactstrap';

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput"

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            nombre: '',
            host: '',
            username: '',
            password: '',
            port:''
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetForm() {
        this.setState({
            descripcion: '',
            casillaDeEmail: '',
            asunto: '',
            cuerpo: ''
        });
    }

    setSelects(data) {
        this.setState({
            nombre: data.nombre,
            host: data.host,
            username: data.username,
            password: data.password,
            port: data.port
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.email.casillas.edit}
                onPreSubmit={this.getData}
                postUrl={api.email.casillas.edit}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                successMessage={"La Casilla de Mail ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Casilla de Mail"}
                buttonTitle={"Editar"}
                buttonIcon={"fa fa-pencil fa-lg"}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
                cancelButtonLabel="Cancelar"
            >
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Nombre"}
                            fieldName={"nombre"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.nombre}
                            onChange={e => this.setState({ nombre: e.target.value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Host"}
                            fieldName={"host"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.host}
                            onChange={e => this.setState({ host: e.target.value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Usuario"}
                            fieldName={"username"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.username}
                            onChange={e => this.setState({ username: e.target.value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Contraseña"}
                            fieldName={"password"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.password}
                            onChange={e => this.setState({ password: e.target.value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Puerto"}
                            fieldName={"port"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.port}
                            onChange={e => this.setState({ port: e.target.value })}
                        />
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Config/Casillas/Edit.js